
export const DgHoldingsSubCategoryType  = {    
    DgHoldingsTopHoldings:0,
    DgHoldingsByPosition:1
};